import { ChangeEvent } from "@mcleod/components";
import { AutogenLayoutDetentionReport } from "./autogen/AutogenLayoutDetentionReport";

export class DetentionReport extends AutogenLayoutDetentionReport {
    
    override async onLoad(): Promise<void> {
        super.onLoad();
    }
    
    textboxRecordTypeOnChange() {
        if(this.textboxRecordType.selectedItem === null ||this.textboxRecordType.selectedItem.displayValue === null || this.textboxRecordType.selectedItem.displayValue === "=") {
            this.textboxBalanceOf.enabled = false;
            this.textboxStatusOf.enabled = false;
            this.textboxStatusOf.text = "";
            this.textboxBalanceOf.text = "";
        }
        else {
            this.textboxBalanceOf.enabled = true;
            this.textboxStatusOf.enabled = true;
        }
    }
    
    switchReportTypeOnChange(event: ChangeEvent) {
        // When Summary is selected (leftValue = "S", checked = false), disable Print Comments checkbox
        // When Detailed is selected (rightValue = "D", checked = true), enable Print Comments checkbox
        this.checkboxPrintComments.enabled = event.newValue;
        // // If switching to Summary, uncheck the Print Comments checkbox
        if (!event.newValue) {
            this.checkboxPrintComments.checked = false;
        }
    }
}